import { createRouter } from '@tanstack/react-router';

import { routeTree } from '../routeTree.gen';
import { queryClient } from './query-client';

export const router = createRouter({
    routeTree,
    context: {
        queryClient,
        currentUser: null,
        isAuthenticated: null!,
    },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 1000 * 60 * 60, // 1 hour
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    // eslint-disable-next-line ts/consistent-type-definitions
    interface Register {
        router: typeof router;
    }
}
